import { useNavigate } from "react-router-dom";
import OnboardingForm from "./OnboardingForm";
import { useEffect } from "react";
import { BusinessState } from "redux-context/business";
import { useSelector } from "react-redux";
import { OnboardingStep } from "enums/OnboardingStep";

const NewWelcome: React.FC = () => {
  const navigate = useNavigate();
  const { business } = useSelector((state: BusinessState) => state.business);

  useEffect(() => {
    if (business.onboardingStep === OnboardingStep.Completed) {
      navigate("/");
    }
  }, [business?.onboardingStep, navigate]);

  return (
    <div className="new-onboarding">
      <OnboardingForm />
    </div>
  );
};
export default NewWelcome;
